import { useState } from 'react'
import { Dialog } from '@mui/material'
import ThreadsSearchDialogHeader from './ThreadsSearchDialogHeader'
import ThreadsSearchDialogSession from './ThreadsSearchDialogSession'
import { THREAD_WORKSPACE_SCOPE } from './threadWorkspaceScope'
import styles from './ThreadsSectionAllThreadsDialog.module.scss'

export default function ThreadsSectionAllThreadsDialog({
  open,
  onClose,
  threads = [],
  selectedThreadId,
  onSelectThread,
  onThreadMenuAction,
  onRenameThread,
}) {
  const [workspaceScope, setWorkspaceScope] = useState(THREAD_WORKSPACE_SCOPE.CURRENT)
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      scroll="paper"
      aria-label="Threads"
      slotProps={{ paper: { className: styles.dialogPaper, elevation: 0 } }}
    >
      <ThreadsSearchDialogHeader
        onClose={onClose}
        workspaceScope={workspaceScope}
        onWorkspaceScopeChange={setWorkspaceScope}
      />
      {open ? (
        <ThreadsSearchDialogSession
          threads={threads}
          workspaceScope={workspaceScope}
          selectedThreadId={selectedThreadId}
          onSelectThread={onSelectThread}
          onClose={onClose}
          onThreadMenuAction={onThreadMenuAction}
          onRenameThread={onRenameThread}
        />
      ) : null}
    </Dialog>
  )
}
